import styled from 'styled-components';

export const SixColumn = styled.div`
  flex-basis: 69%;

  @media (max-width: 720px) {
    flex-basis: 100%;
  }

  & .ansloadmoreButton {
    margin: 1em 2em;
  }
`;

export const Greybg = styled.div`
  margin-top: 16px;
  padding: 4px 20px 16px;
  background-color: hsl(0deg, 0%, 0%, 2%);

  @media (max-width: 720px) {
    margin: 2px 0;
    padding: 4px 10px 16px;
  }
`;

export const ReadMoreReplies = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.videoPage ? 'center' : 'flex-start')};
  color: ${(props) => (props.videoPage ? '#ef4e5e' : 'hsl(0deg, 0%, 0%, 87%)')};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 16px 0;

  @media (max-width: 720px) {
    cursor: default;
    padding: 0px 18px;
    display: flex;
    justify-content: space-between;
  }

  img {
    width: 12px;
    height: 12px;
    margin-left: 6px;
    transform: rotate(270deg);
  }

  .vermArrow {
    width: 10px;
    height: 10px;
    margin-left: 6px;
    margin-bottom: 3px;
    transform: rotate(270deg);
  }

  .light {
    color: #0000008a;
  }
`;

export const QuestionContainer = styled.section`
  @media (min-width: 720px) {
    order: 0;
  }
`;

export const UserComments = styled.h5`
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 60%);
  padding: 14px 0;
`;
